<div class="cardSliderWrap">
    <div class="maxContainerWidth">
        <div class="heading">
            <h4 class="text-gradient">
                Payment Methods
            </h4>
            <h2>
                The most powerful and secure <br class="hidden"> payment gateway
            </h2>
        
        </div>
        <div class="sliderWrap flex md:flex-row flex-col justify-center items-start" >
            <div class="slideImageWrap">
                    <img src="assets/images/payment-gateway/{{imgSrc}}" alt="">
            </div>
            <div class="sliderTextWrap">
                <div class="sliderText">
                    <div *ngFor="let slide of sliderData ; let i = index;" >
                        
                    <p [ngClass]="{'active': i == currentIndex}">
                        {{slide.text}}
                    </p>
                    </div>
                    
                </div>
                <div class="sliderBtn">
                    <button (click)="move(-1)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                            <path d="M11.9375 21.4194L11.9375 1.92518" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M21.0752 11.6724L11.6327 1.92524L2.19014 11.6724" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                    </button>
                    <button (click)="move(1)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
                            <path d="M11.9375 2.01709L11.9375 21.5113" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M21.0752 11.7642L11.6327 21.5113L2.19014 11.7642" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>